import { Injectable, ErrorHandler, inject, Injector } from "@angular/core";
import { LoggingService } from "../logging.service";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { environment } from "../../../environments/environment";

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
    constructor(private readonly inj: Injector) {
        super();
    }

    override handleError(error: Error): void {
        let _loggingService = this.inj.get(LoggingService)
        _loggingService.logException(error, SeverityLevel.Error);
        
        if (!environment.production) {
            console.error(error);
        }
    }
}